<div class="search-form" [formGroup]="searchForm">
	<mat-form-field
		class="mr-xxxs search-field"
		title="Busca de beneficiários"
		appearance="outline"
	>
		<mat-label>Pesquisar</mat-label>
		<input
			type="text"
			matInput
			placeholder="Pesquisar"
			formControlName="term"
			id="sms-sro-{{ inputId }}"
			(keyup)="onSearchKeyUp($event)"
		/>
		<button
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Clear search"
			(click)="onClearSearch()"
			*ngIf="!searchButton"
		>
			<mat-icon>close</mat-icon>
		</button>
		<button
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Search beneficiaries"
			[disabled]="disableSearchBtn"
			(click)="getScoreList(true)"
			*ngIf="searchButton"
		>
			<mat-icon>search</mat-icon>
		</button>
	</mat-form-field>
	<div class="d-f jc-fe ai-c">
		<p class="margin-right-8">Planilha:</p>
		<div class="d-f jc-c ai-c xlsx-spinner" *ngIf="downloading">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
		<button
			id="download-button"
			mat-flat-button
			color="primary"
			(click)="onDownloadXlsx()"
			*ngIf="!downloading"
		>
			<span>Download</span>
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<ng-container *ngIf="(loading$ | async) === false">
	<div
		class="pos-r mb-xxxs pb-nano br-md card"
		*ngFor="let score of scores$ | async; let index = index"
	>
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f jc-sb ai-c mb-xxxs ml-xxxs card-top">
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Beneficiário</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.beneficiary | titlecase }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Empresa</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.organization }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col date">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Data da criação</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.created_at | date: 'dd/MM/YYYY' }}
					</span>
				</div>
			</div>
			<div class="d-f jc-sb ai-c mb-xxxs ml-xxxs card-middle">
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Estresse</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.stress }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Come frituras</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.eatsFriedFood }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Última vez médico</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.lastTimeAtTheDoctor }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Medicação contínua</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.continuousMedication | titlecase }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Atividade física</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.physicalActivity }}
					</span>
				</div>
			</div>
			<div class="d-f ai-c ml-xxxs card-bottom">
				<div class="d-f fd-c jc-c col info">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Nota Média</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.averageGrade }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col info">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Risco</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.risk }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col info">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Score</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ score.score }}
					</span>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<div class="mb-huge"></div>
